module.exports = __webpack_public_path__ + "img/index-section7-award8.08a9218e.png";